import React from 'react';
import format from 'date-fns/format';
import EmployeeLink from '@/components/common/EmployeeLink';
import translate from '@/lib/intl/translate';
import MetaContentType from '../constants/MetaContentType';

type EntityDetailsMetaContentProps = {
  date: string;
  type: MetaContentType;
  user?: {
    userId?: string;
    displayName?: string;
  };
};

export default function EntityDetailsMetaContent({
  date,
  type,
  user,
}: EntityDetailsMetaContentProps) {
  if (!user?.displayName || !user?.userId) {
    return null;
  }

  const translation =
    type === MetaContentType.ADDED_BY
      ? 'ENTITY_DETAILS_ADDED_BY'
      : 'ENTITY_DETAILS_UPDATED_BY';

  return (
    <div>
      {translate(translation, {
        date: format(new Date(date), 'PPPp'),
        developerLink: (
          <EmployeeLink
            classes={{ link: 'type-caption1' }}
            displayName={user.displayName}
            userId={user.userId}
          />
        ),
      })}
    </div>
  );
}

EntityDetailsMetaContent.type = MetaContentType;
